<template>
  <div class="page height-full">
    <app-header title="Analytics"/>
    <div class="container-fluid" v-if="isLoading">
      <spinner style="margin-top: 25%"></spinner>
    </div>
    <div class="container-fluid" v-else>
      <b-card class="mt-3"> 
        <b-row>
          <b-col md=12 class="mb-3">
            <span><strong class="mr-2">Client Acquisition</strong>(This month)</span>
          </b-col>
          <b-col md=4>
            <span><strong class="mr-2">Contacts</strong></span>
            <p>{{dashboard.acquisition.contacts}}</p>
          </b-col>
          <b-col md=4 class="border-left">
            <span><strong class="mr-2">Applications</strong></span>
            <p>{{dashboard.acquisition.applications}}</p>
          </b-col>
          <b-col md=4 class="border-left">
            <span<strong class="mr-2">New Accounts</strong></span>
            <p>{{dashboard.acquisition.newAccounts}}</p>
          </b-col>
        </b-row>
      </b-card>
      <b-card class="mt-3"> 
        <b-row>
          <b-col md=12 class="mb-3">
            <span><strong class="mr-2">Ad Performance</strong>(This month)</span>
          </b-col>
          <b-col md=4>
            <span><strong class="mr-2">Sales Generated</strong></span>
            <p>{{'$' + Number(dashboard.performance.sales).toFixed(2)}}</p>
          </b-col>
          <b-col md=4 class="border-left">
            <span><strong class="mr-2">Leads Generated</strong></span>
            <p>{{dashboard.performance.leads}}</p>
          </b-col>
          <b-col md=4 class="border-left">
            <span><strong class="mr-2">Est. Revenue</strong></span>
            <p>{{'$' + Number(dashboard.performance.commission).toFixed(2)}}</p>
          </b-col>
        </b-row>
      </b-card>
      <b-card class="mt-3 mb-3"> 
        <b-row>
          <b-col md=12>
            <span><strong class="mr-2">Funnel Insights</strong></span>
            <b-col md=12>
              <div class="white r-5">
                <div class="funnel" ref="funnel"></div>
              </div>
            </b-col>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
  import 'vue-loading-overlay/dist/vue-loading.css'
  import { Auth } from 'aws-amplify';
  import axios from 'axios'
  import Constants from '../Constants'
  import Spinner from './common/Spinner'
  import SimpleChart from './SimpleChart'
  import Vue from 'vue'

  // FunnelGraph
  import FunnelGraph from 'funnel-graph-js'
  import 'funnel-graph-js/dist/css/main.min.css'
  import 'funnel-graph-js/dist/css/theme.min.css'

  import DateRangePicker from 'vue2-daterange-picker'
  //you need to import the CSS manually (in case you want to override it)
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

  // Search select...
  import { ModelSelect } from 'vue-search-select'
  import 'vue-search-select/dist/VueSearchSelect.css'

  export default {
    name: 'Analytics',
    components: {
      Spinner,
      SimpleChart,
      DateRangePicker,
      ModelSelect
    },
    data() {
      return {
        dashboard: {
          acquisition: {
            contacts: 0,
            applications: 0,
            newAccounts: 0
          },
          performance: {
            sales: 0,
            leads: 0,
            commission: 0, 
            adSpend: 0
          }
        },
        options: [
          { value: '1', text: 'aa' + ' - ' + '1' },
          { value: '2', text: 'ab' + ' - ' + '2' },
          { value: '3', text: 'bc' + ' - ' + '3' },
          { value: '4', text: 'cd' + ' - ' + '4' },
          { value: '5', text: 'de' + ' - ' + '5' }
        ],
        item: {
          value: '',
          text: ''
        },
        selectedForm: null,
        forms: [
          { value: null, text: 'All Forms' },
          { value: 'cuvee', text: 'Cuveé Coffee' },
          { value: 'doomz', text: 'DoomzDNA' },
        ],
        dateRange: {
          startDate: '',
          endDate: '',
        },
        maxDate: new Date(),
        minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
        dateOptions: {
          day: 'numeric', 
          month: 'numeric',
          year: 'numeric'
        },
        localeData: {
          direction: 'ltr',
          format: 'mm/dd/yyyy',
          separator: ' - ',
          applyLabel: 'Apply',
          cancelLabel: 'Cancel',
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          firstDay: 0
        },
        picker: {
          opens: 'left',
          showWeekNumbers: false,
          showDropdowns: true,
          autoApply: false,
          startDate: '2020-06-28',
          endDate: '2020-06-28',
          dateRange: {
            startDate: '2020-06-28',
            endDate: '2020-06-28'
          },
          linkedCalendars: true
        },
        accountData: {},
        chartsLib: null,
        showDialog: false,
        isLoading: false,
        chartData: {
          dates: [],
          traffic: [],
          revenue: [],
        },
        plan: '',
        messagesOptions: {
          chart: {
            title: "Messages Performance",
            subtitle: 'Last 30 days',
          },
          height: 500,
          maxLines: 7,
          legend: {position: 'none'},
          width: 100
        },
        subscribersData: [],
        subscribersOptions: {
          chart: {
            title: 'Subscribers Performance',
            subtitle: 'Last 30 days',
          },
          height: 500,
          maxLines: 7,
          legend: {position: 'none'}
        },
        dashboard: {
          subscriberCount: 0,
          credits: 0,
          phoneNumbers: []
        },
        showChart: false,
        items: [
          {
            name: 'Cuveé Coffee',
            visitors: 123,
            clicks: 21,
            clickThruRate: '21%',
            purchases: 7,
            revenue: '$146.28',
            discounts: '$26.81',
            roas: 1.72
          },
          {
            name: 'DoomzDNA',
            visitors: 123,
            clicks: 21,
            clickThruRate: '21%',
            purchases: 7,
            revenue: '$146.28',
            discounts: '$26.81',
            roas: 1.72
          },
          {
            name: 'Cuveé Coffee',
            visitors: 123,
            clicks: 21,
            clickThruRate: '21%',
            purchases: 7,
            revenue: '$146.28',
            discounts: '$26.81',
            roas: 1.72
          },
          {
            name: 'DoomzDNA',
            visitors: 123,
            clicks: 21,
            clickThruRate: '21%',
            purchases: 7,
            revenue: '$146.28',
            discounts: '$26.81',
            roas: 1.72
          },
          {
            name: 'Cuveé Coffee',
            visitors: 123,
            clicks: 21,
            clickThruRate: '21%',
            purchases: 7,
            revenue: '$146.28',
            discounts: '$26.81',
            roas: 1.72
          },
          {
            name: 'DoomzDNA',
            visitors: 123,
            clicks: 21,
            clickThruRate: '21%',
            purchases: 7,
            revenue: '$146.28',
            discounts: '$26.81',
            roas: 1.72
          }
        ]
      }
    },
    methods: {
      reset () {
        this.item = {}
      },
      selectFromParentComponent1 () {
        // select option from parent component
        this.item = this.options[0]
      },
      dateFormat (classes, date) {
        if (!classes.disabled) {
          classes.disabled = date.getTime() < new Date()
        }
        return classes
      },
      getAnalytics() {
        this.resetChartData()
        this.isLoading = true

        axios.get(Constants.API_URL + '/admin/analytics')
          .then(response => {
            console.log(response)
            this.dashboard = response.data
          }).catch(err => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          }).then(() => {
            this.showFunnel()
          })

      },
      checkSession() {
        this.currentSession = null
        Auth.currentSession()
          .then(data => {
            this.configureAxios(data.idToken)
            console.log("session token")
            console.log(data)
            this.currentSession = data
          })
          .catch(err => {
            console.log(err)
            this.currentSession = null
          });
      },
      configureAxios(data) {
        let self = this;
        axios.interceptors.request.use(
          (config) => {
            let token = data.jwtToken
            config.headers['Authorization'] = `Bearer ${token}`;
            return config;
          },
          function (error) {
            return Promise.reject(error);
          }
        );
        axios.interceptors.response.use(response => {
          return response;
        }, function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            return Promise.reject(error)
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
            return Promise.reject(error)
            // self.checkSession()
            // self.$router.go()
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
            return Promise.reject(error)
          }
        });
      },
      updateValues(event) {
        this.getAnalytics()
      },
      checkOpen(event) {
        console.log('checkOpen()')
        console.log(event)
      },
      onChartReady(chart, google) {
        this.chartsLib = google
      },
      dismissOnboarding: function() {
        this.showDialog = false
      },
      formatPhoneNumbers(numbers) {
        var str = ""
        console.log(numbers)
        if (numbers.length == 0) { return str }

        var n = numbers.split(",")
        console.log(n)
        for (var i = 0; i < n.length; i++) {
          var phone = n[i]
          str += Constants.FORMAT_PHONE_NUMBER(phone) + "\n"
        }
        return str        
      },
      resetChartData() {
        this.chartData = {
          dates: [],
          traffic: [],
          revenue: []
        }
      },
      processCharts(chartArray) {
        chartArray = chartArray.reverse()
        if (chartArray.length > 0) {
          this.resetChartData()
          chartArray.forEach((item) => {
            let date = item.sk.split("|")[1];
            date = this.$moment(date, 'MM-DD').format('MMMM Do YYYY')
            let tmp = [date, item.subscribers, item.unsubscribers]
            let messages = [date, item.messagesSent, item.messagesFailed]
            this.messageData.dates.push(date)
            this.messageData.values.push(item.messagesSent)
            this.subscriberData.dates.push(date)
            this.subscriberData.values.push(item.subscribers)
          });
        }
      },
      createTestChart(chartId, chartData) {
        const ctx = document.getElementById(chartId);
        const myChart = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
      },
      upgrade() {
        this.$router.push('/plans')
      },
      billing() {
        if (localStorage.stripeCustomerId) {
          axios.get(Constants.API_URL + '/stripe/billing?customerId=' + localStorage.stripeCustomerId)
            .then(response => {
              if (response.data.url) {
                window.location.href = response.data.url
              }
            }).catch(err => {
              console.error(err)
            })
        } else {
          this.$router.push('/plans')
        }
      },
      showFunnel() {
        var dataExample3 = {
            labels: ['Leads', 'Applications', 'Accounts'],
            subLabels: ['Contacts'],
            colors: [
                ['#A0BBFF', '#EC77FF'],
            ],
            values: [
                [this.dashboard.acquisition.contacts],
                [this.dashboard.acquisition.applications],
                [this.dashboard.acquisition.newAccounts]
            ],
        };
        var graph = new FunnelGraph({
            container: '.funnel',
            gradientDirection: 'horizontal',
            data: dataExample3,
            displayPercent: true,
            direction: 'horizontal',
            subLabelValue: 'raw',
            height: 300,
            width: this.$refs.funnel.clientWidth
        });

        console.log('Built funnel...')
        console.log(graph)

        graph.draw();
      }
    },
    mounted() {
      this.checkSession()
      const date = new Date()
      const str = date.toLocaleString('en-us', this.dateOptions)
      this.dateRange.startDate = str
      this.dateRange.endDate = str
      this.getAnalytics()
    }
  }
</script>
<style>
  .alert {
    margin-top: 16px;
  }

  .credits {
    color: dimgray;
  }

  .upgrade {
    position: relative;
    float: right;
  }

  .upgrade a {
    text-decoration: blue;
  }

  .description {
    margin-top: 20px;
  }

  .md-dialog-actions {
    justify-content: center;
    padding: 0;
  }

  .centered {
    text-align: center;
    display: block;
    width: 100%;
  }

  .content {
    margin-left: 100px;
    margin-right: 100px;

  }

  .content-bottom {
    margin-bottom: 50px;
  }

  .btn-gray {
    margin-bottom: 20px;
    background-color: #e3e3e3;
    color: white;
    text-align: center;
  }

  .counter-box {
    height: 100%;
  }

  .border-left {
    border-left: 2px solid black;
  }
</style>



// WEBPACK FOOTER //
// src/components/Analytics.vue